import type { IUser } from "@/types/users";
import { UserRole } from "@/types/users";

export type ISuperAdmin = IUser & {
  userId: number;
  role: UserRole.SuperAdmin;
};

export const isSuperAdmin = (user: IUser): user is ISuperAdmin => {
  return user.role === UserRole.SuperAdmin;
};
